import type { AvisoResumen } from '../../hooks/useAvisos'
import { InsigniaEstado } from './InsigniaEstado'
import { MarcaSemanas } from './MarcaSemanas'
import { formatearFechaCorta } from './formato'

/**
 * Version movil de una fila. La tabla tiene siete columnas: a 375 px obligaria
 * a desplazarse en horizontal para leer un solo cliente. La tarjeta pone
 * primero lo que decide la llamada (semanas sin pedir y su marca) y deja los
 * datos de apoyo debajo.
 */
export function TarjetaAviso({ aviso }: { aviso: AvisoResumen }) {
  const ultimoAlbaran = formatearFechaCorta(aviso.fecha_ultimo_albaran)
  const ultimoAviso = formatearFechaCorta(aviso.fecha_ultimo_aviso)

  return (
    <li className="rounded-xl border border-borde bg-superficie px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <p className="min-w-0 flex-1 truncate text-sm font-medium text-tinta">
          {aviso.nombre}
        </p>
        <InsigniaEstado estado={aviso.estado} />
      </div>

      <p className="mt-2 text-sm">
        <MarcaSemanas semanas={aviso.semanas_sin_pedir} conUnidad />
        <span className="text-tinta-apagada"> sin pedir</span>
      </p>

      <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 text-sm text-tinta-apagada">
        <div className="col-span-2 flex gap-2">
          <dt className="shrink-0">Telefono</dt>
          <dd className="truncate text-tinta-2">{aviso.telefono ?? 'Sin telefono'}</dd>
        </div>
        <div className="flex gap-2">
          <dt className="shrink-0">Albaran</dt>
          <dd className="truncate text-tinta-2">{ultimoAlbaran ?? 'Sin albaran'}</dd>
        </div>
        <div className="flex gap-2">
          <dt className="shrink-0">Aviso</dt>
          <dd className="truncate text-tinta-2">{ultimoAviso ?? 'Sin avisar'}</dd>
        </div>
        {aviso.aplazamientos_consecutivos > 0 ? (
          <div className="col-span-2 flex gap-2">
            <dt className="shrink-0">Aplazamientos</dt>
            <dd className="text-tinta-2">{aviso.aplazamientos_consecutivos}</dd>
          </div>
        ) : null}
      </dl>
    </li>
  )
}
